
<div mat-dialog-title>Model Allocations<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div class="model-used-in-rebalance-component" id="model-used-in-rebalance-component">

    <div style="border-bottom:1px solid #ccc !important; margin-bottom:10px; padding-bottom:10px;">
      <div class="bold">Model: {{portfolioResultData?.historyModelName}}</div>
    </div>
    <div>
      <div style="margin-bottom: 10px;">
        <strong> {{portfolioSummaryData?.modelHistoryList?.length}} Securities</strong>
      </div>
    </div>
    @if (!isUiTest) {
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "this.defaultGridHeights.height"
        [style.minHeight]="this.defaultGridHeights.minHeight"
        [style.maxHeight]="this.defaultGridHeights.maxHeight"
        [domLayout]="this.defaultGridHeights.domLayout"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [rowData]="this.portfolioSummaryData?.modelHistoryList"
        [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    }
    <div class="allocation-totals-row" >
      <div style="position: relative;">
        Total Security Allocations:
        <div style="position: absolute;top: 3px;" id="model-allocation-total-percent-value"
        [style]="{color: totalPercent === 100 ? '#188800' : '#C11312'}"></div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button  id="closeButton" (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>
